import {toast} from "react-toastify"
import TomClient from "../../../anwendungskonfigurator/services/tomClient"
import {debounce, errorParser} from "../../../anwendungskonfigurator/misc/utils"
import _ from "lodash"
import {useRef} from "react"

const sortErgebnis = (data, property) => {
    if (!property) {
        return null
    }
    const gesamt = _.omit(
        data?.ergebnisse[property]?.find(
            (entry) => entry.einzelgefahr === "GESAMT",
        ),
        ["praemievormindestpraemie", "mindestpraemie"],
    )
    const ec = _.omit(
        data?.ergebnisse[property]?.find(
            (entry) => entry.einzelgefahr === "EC",
        ),
        ["praemievormindestpraemie", "mindestpraemie"],
    )
    if (!gesamt && !ec) {
        return data
    }
    const restructuredResult = data.ergebnisse[property].filter(
        (entry) =>
            !(entry.einzelgefahr === "EC" || entry.einzelgefahr === "GESAMT"),
    )

    data.ergebnisse[property] = [...restructuredResult, ec, gesamt]
}

const mapKalkulationData = (kalkulationData) => {
    try {
        if (!kalkulationData?.ergebnisse?.cyber) {
            sortErgebnis(kalkulationData, "gesamtSach")
            sortErgebnis(kalkulationData, "gesamtBU")
            kalkulationData.sparte = "SACH"
        } else if (kalkulationData) {
            kalkulationData.sparte = "CYBER"
        }
        return kalkulationData
    } catch (error) {}
}

export const KalkulationActions = ({
    getDataFromPointer,
    sendDataToBackend,
    updateData,
    loadCurrentLocationData,
}) => {
    const debouncedSendDataRef = useRef()

    if (!debouncedSendDataRef.current) {
        debouncedSendDataRef.current = debounce(sendDataToBackend, 500)
    }

    return {
        CALCULATE: () => {
            TomClient.callHallink(
                getDataFromPointer("/kalkulation/_links/update"),
                getDataFromPointer("/kalkulation"),
            )
                .then(
                    () => {
                        return TomClient.callHallink(
                            getDataFromPointer("/kalkulation/_links/calculate"),
                        )
                    },
                    errorParser(updateData, "kalkulation"),
                )
                .then((kalkulationsResponse) => {
                    updateData(kalkulationsResponse["_data"], "/kalkulation")
                    updateData(kalkulationsResponse["_links"], "/links")
                })
        },
        SAVE_KALKULATION: () => {
            TomClient.callHallink(
                getDataFromPointer("/kalkulation/_links/update"),
                getDataFromPointer("/kalkulation"),
                mapKalkulationData,
            ).then(
                () => {
                    toast.success("Kalkulation wurde gespeichert")
                },
                errorParser(updateData, "kalkulation"),
            )
        },
        INIT_KALKULATION: () => {
            loadCurrentLocationData("/kalkulation", mapKalkulationData).then(
                (errorParser(updateData, "kalkulation")
            ))
        },
        SAVE_TARIFUNTERSCHREITUNG: () => {
            debouncedSendDataRef.current(
                getDataFromPointer(
                    "/kalkulation/_links/calculateByTarifunterschreitung",
                ),
                getDataFromPointer("/kalkulation"),
                "/kalkulation",
                mapKalkulationData,
            )
        },
        SAVE_TARIFUNTERSCHREITUNGNETTOBEITRAEGE: () => {
            debouncedSendDataRef.current(
                getDataFromPointer(
                    "/kalkulation/_links/calculateByTarifunterschreitungAusNettobeitrag",
                ),
                getDataFromPointer("/kalkulation"),
                "/kalkulation",
                mapKalkulationData,
            )
        },
        SAVE_BEZUGSPRAEMIENSATZ: () => {
            debouncedSendDataRef.current(
                getDataFromPointer(
                    "/kalkulation/_links/calculateByBezugspraemiensatz",
                ),
                getDataFromPointer("/kalkulation"),
                "/kalkulation",
                mapKalkulationData,
            )
        },
    }
}
